import React from "react";
import "./VC.css";
import VCHeroImg from "../../../Gallery/ServicesImages/VC/VC.png"; 
import { useEffect } from "react";


import Img1 from "../../../Gallery/ServicesImages/VC/img1.png";
import Img2 from "../../../Gallery/ServicesImages/VC/img2.png";
import Img3 from "../../../Gallery/ServicesImages/VC/img3.png";
import Img4 from "../../../Gallery/ServicesImages/VC/img4.png";




function VC() {

  useEffect(() => {
  const elements = document.querySelectorAll(".fade_in_up");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        }
      });
    },
    { threshold: 0.2 }
  );

  elements.forEach((el) => observer.observe(el));
}, []);


  return (
    <div className="vc_wrapper">

      {/* HERO SECTION */}
      <section className="vc_hero_section">
        <img src={VCHeroImg} alt="Vacuum Casting" className="vc_hero_img" />

        <div className="vc_hero_overlay"></div>

        <div className="vc_hero_content">
          <h1>
            Low Volume,<br />
            High Quality Vacuum<br />
            Casting Services in India
          </h1>

          <p>Perfect for prototypes & short production runs</p>

      
        </div>
      </section>

     {/* NEW — WHAT IS VACUUM CASTING (Fresh Modern Look) */}
<section className="vc_modern_section">

  <div className="vc_modern_inner">

    <h2 className="vc_modern_heading">What Is Vacuum Casting?</h2>
    <div className="vc_modern_line"></div>

    <p className="vc_modern_text">
      Vacuum Casting is a precise low-volume manufacturing process that uses 
      silicone molds to replicate high-quality plastic components. It delivers 
      smooth surface finish, accurate geometries, and material performance 
      suitable for prototypes and small-batch functional parts.
    </p>

  </div>

</section>

{/* NEW – VACUUM CASTING PRODUCTS */}
{/* NEW – VACUUM CASTING PRODUCTS WITH ANIMATION */}
<section className="vc_products_section">

  {/* TITLE */}
  <div className="vc_products_title_wrap fade_in_up">
    <h2 className="vc_products_title">Vacuum Casting Products</h2>
    <div className="vc_products_line"></div>
  </div>

  <p className="vc_products_subtext fade_in_up">
    Vacuum casting allows the production of highly detailed, smooth-finish parts 
    suitable for prototypes, functional testing, and small-batch manufacturing.
  </p>

  {/* IMAGE GRID */}
  <div className="vc_products_grid">

    <div className="vc_products_card fade_in_up">
      <img src={Img1} alt="Vacuum Casting Part" />
    </div>

    <div className="vc_products_card fade_in_up">
      <img src={Img2} alt="Vacuum Casting Part" />
    </div>

    <div className="vc_products_card fade_in_up">
      <img src={Img3} alt="Vacuum Casting Part" />
    </div>

    <div className="vc_products_card fade_in_up">
      <img src={Img4} alt="Vacuum Casting Part" />
    </div>

  </div>

</section>
{/* 
<section className="vc_adv_compact">

  <h2 className="vc_adv_compact_title">Advantages of Vacuum Casting</h2>
  <p className="vc_adv_compact_subtext">
    Vacuum casting provides fast, accurate and cost-efficient parts ideal for prototypes and
    low-volume production.
  </p>

  <div className="vc_adv_compact_grid">

    <div className="vc_adv_compact_card fade_up">
      <div className="vc_adv_compact_icon">
        <i className="fas fa-clock"></i>
      </div>
      <h3>Fast</h3>
      <p>Quick turnaround and low cost compared to 3D printing or injection moulding.</p>
    </div>

    <div className="vc_adv_compact_card fade_up">
      <div className="vc_adv_compact_icon">
        <i className="fas fa-chart-line"></i>
      </div>
      <h3>Scalability</h3>
      <p>Easily produce parts in low volume, from a few pieces to hundreds.</p>
    </div>

    <div className="vc_adv_compact_card fade_up">
      <div className="vc_adv_compact_icon">
        <i className="fas fa-box"></i>
      </div>
      <h3>Ready To Go</h3>
      <p>No post-processing required. Parts come clean and ready for use.</p>
    </div>

    <div className="vc_adv_compact_card fade_up">
      <div className="vc_adv_compact_icon">
        <i className="fas fa-cubes"></i>
      </div>
      <h3>Wide Material Range</h3>
      <p>Choose flexible or rigid polyurethane materials based on requirements.</p>
    </div>

  </div>

</section> */}

{/* NEW – MATERIALS USED IN VACUUM CASTING */}
<section className="vc_materials_grid_section">

  <div className="vc_materials_grid_title_wrap">
    <h2 className="vc_materials_grid_title">Materials Used In Vacuum Casting</h2>
    <div className="vc_materials_grid_line"></div>
  </div>

  <div className="vc_materials_grid">

    {/* ABS */}
    <div className="vc_material_card">
      <h3>ABS</h3>
      <p>
        Acrylonitrile butadiene styrene is popular due to its low production cost. 
        We offer ABS-like materials such as PX223 (Axon) and SG95 (Renishaw).
      </p>
    </div>

    {/* PP */}
    <div className="vc_material_card">
      <h3>PP</h3>
      <p>
        Polypropylene is widely used and easy to mould. We offer PP-like materials 
        like 8045 (Renishaw).
      </p>
    </div>

    {/* GLASS FILLED */}
    <div className="vc_material_card">
      <h3>Glass Filled</h3>
      <p>
        Glass-filled polymers offer increased strength & rigidity. We offer 
        30% glass-filled VC3368 (Alchemi).
      </p>
    </div>

    {/* PC */}
    <div className="vc_material_card">
      <h3>PC</h3>
      <p>
        Polycarbonate provides high impact resistance and comes in clear grades. 
        We offer PC-like materials such as Transparent 5210 and 1810.
      </p>
    </div>

    {/* WAX */}
    <div className="vc_material_card">
      <h3>Wax</h3>
      <p>
        Wax can be formed into any shape and is great for texture replication. 
        Available in wire, sheets, and sprues.
      </p>
    </div>

    {/* RUBBER */}
    <div className="vc_material_card">
      <h3>Rubber</h3>
      <p>
        Used for flexible components. Excellent for soft-touch prototypes. 
        Available in multiple hardness grades.
      </p>
    </div>

  </div>

</section>






    </div>
  );
}

export default VC;
